module.exports = __webpack_public_path__ + "img/demobg.128c9e59.png";